module.exports = __webpack_public_path__ + "static/media/5580.f7b7c8f9.jpg";